<template>
    <div class="header-box" :class="[isSmall ? 'small-header': 'big-header']">
        <div class="logo-box">
            <img :src="$utils.getFileHttpUrl(baseConf.logo)" >
            <div v-if="!isSmall" class="logo-name">{{ baseConf.name }}</div>
        </div>
        <div class="nav-box">
            <div class="nav-item" :class="{'nav-active': activeTab == 'home'}" @click="gotoPage('home')">首页</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'enterprise'}" @click="gotoPage('enterpriseIndex')">企业概况</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'bizScope'}" @click="gotoPage('bizScope')">业务范畴</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'case'}" @click="gotoPage('case')">服务案例</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'honor'}" @click="gotoPage('honor')">资质荣誉</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'news'}" @click="gotoPage('news')">新闻中心</div>
            <div class="nav-item" :class="{'nav-active': activeTab == 'contact'}" @click="gotoPage('contact')">联系我们</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            realRouteName: 'home',
            activeTab: 'home',
            isSmall: false,
            baseConf: {}
        }
    },
    watch: {
        '$route': {
            immediate: true,
            handler(to, from) {
                this.realRouteName = to.name
                console.log('路由：', to, from)
                if(to.name == 'bizScopeDetail') {
                    this.activeTab = 'bizScope'
                } else if(to.name == 'caseDetail'){
                    this.activeTab = 'case'
                } else if(to.name == 'newsDetail') {
                    this.activeTab = 'news'
                } else if (to.name == 'enterpriseIndex' || to.name == 'enterpriseTech') {
                    this.activeTab = 'enterprise'
                }else {
                    this.activeTab = to.name
                }
                if(from?.name == 'home') {
                    localStorage.setItem("isFromHome", 1)
                } else {
                    localStorage.setItem("isFromHome", 0)
                }
            }
        }
    },
    created() {
        this.getBaseConf()
        // console.log("视口宽度: " + window.innerWidth + "px");
        this.isSmall = window.innerWidth < 1200

        let resizeTimeout;
        window.onresize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // console.log("窗口大小已变化");
                // console.log("新的窗口高度: " + window.innerHeight);
                this.isSmall = window.innerWidth < 1200
                // console.log("新的窗口宽度: " + window.innerWidth, this.isSmall);
            }, 100); // 延迟100毫秒执行
        };
    },
    methods: {
        gotoPage(name) {
            if(this.realRouteName == name) {return}
            this.$router.replace({name: name})
        },
        getBaseConf() {
            this.$http.getAction('/portal/api/v1/index/base/conf').then(res => {
                if(res.success) {
                    this.baseConf = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .header-box {
        display: flex;
        align-items: center;
        height: 96px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
        min-width: 1200px;

        .logo-box {
            display: flex;
            align-items: center;
            img {
                width: 40px;
                height: 40px;
                object-fit: cover;
                margin-right: 20px;
            }
            .logo-name {
                // font-family: AliHYAiHei, AliHYAiHei;
                font-weight: 400;
                font-size: 20px;
                color: #000000;
            }
        }

        .nav-box {
            display: flex;
            align-items: center;
            
            .nav-item {
                width: 80px;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                text-align: center;
                margin-right: 58px;
                // font-family: AliHYAiHei, AliHYAiHei;
                cursor: pointer;
                &:nth-of-type(7) {
                    margin-right: 0;
                }
            }
            .nav-active {
                position: relative;
                color: #0282DE;
                &::after {
                    position: absolute;
                    bottom: -16px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: block;
                    content: '';
                    width: 32px;
                    height: 3px;
                    background: #0282DE;
                }
            }
        }


    }
    .small-header {
        justify-content: space-around;
    }
    .big-header {
        padding-left: 120px;
        .logo-box {
            margin-right: 195px;
        }
    }
</style>